import { useEffect, useState } from "react";
import axios from "axios";
import AdminLayout from "../layout/AdminLayout";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";

const AdminFraudDetails = () => {
  const { fraudId } = useParams();
  const navigate = useNavigate();

  const [fraud, setFraud] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ NEW STATES (Edit Feature)
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const fetchFraud = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const response = await axios.get(
        `${API_BASE_URL}/api/admin/frauds/${fraudId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setFraud(response.data);
      setFormData(response.data); // ✅ important
      setLoading(false);

    } catch (error) {
      console.error("Error loading fraud:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFraud();
  }, []);

  const approveFraud = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      await axios.put(
        `${API_BASE_URL}/api/admin/frauds/${fraudId}/approve`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      fetchFraud();

    } catch (error) {
      console.error("Approve failed:", error);
    }
  };

  const rejectFraud = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      await axios.put(
        `${API_BASE_URL}/api/admin/frauds/${fraudId}/reject`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      fetchFraud();

    } catch (error) {
      console.error("Reject failed:", error);
    }
  };

  // ✅ SAVE EDITED DATA
  const saveChanges = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      await axios.put(
        `${API_BASE_URL}/api/admin/frauds/${fraudId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setIsEditing(false);
      fetchFraud();

    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <p>Loading...</p>
      </AdminLayout>
    );
  }

  if (!fraud) {
    return (
      <AdminLayout>
        <p>Fraud not found</p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-page-wrapper">

        <div className="admin-header">
          <p className="admin-welcome">Fraud Details</p>
          <h2 className="admin-title">
            Fraud Case #{fraud._id}
          </h2>
        </div>

        <div className="admin-action-bar">

          {/* ✅ Edit Button */}
          {!isEditing && (
             <button
             className="edit-btn"
              onClick={() => setIsEditing(true)}
             >
              ✏ Edit
             </button>
            )}

          {fraud.status === "pending" && (
            <>
              <button className="approve-btn" onClick={approveFraud}>
                Approve Fraud
              </button>

              <button className="reject-btn" onClick={rejectFraud}>
                Reject Fraud
              </button>
            </>
          )}

          <button className="admin-back-btn" onClick={() => navigate(-1)}>
            ← Back
          </button>
        </div>

        <div className="admin-card admin-fraud-full-card">
          <div className="admin-fraud-grid">

            <div>
              <h4>Fraudster</h4>

              <p>
                <strong>Name:</strong>{" "}
                {isEditing ? (
                  <input
                    value={formData.fullName || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, fullName: e.target.value })
                    }
                  />
                ) : (
                  fraud.fullName
                )}
              </p>

              <p>
                 <strong>Phone:</strong>{" "}
                  {isEditing ? (
                  <input
                  value={formData.phoneNumbers?.[0] || ""}
                 onChange={(e) =>
                  setFormData({
                  ...formData,
                 phoneNumbers: [e.target.value]
                 })
                  }
                  />
                 ) : (
                 fraud.phoneNumbers?.join(", ")
                  )}
                </p>

              <p>
                <strong>Aadhaar:</strong>{" "}
                {isEditing ? (
                  <input
                    value={formData.aadhaarNumber || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, aadhaarNumber: e.target.value })
                    }
                  />
                ) : (
                  fraud.aadhaarNumber
                )}
              </p>

              <p>
                <strong>DL:</strong>{" "}
                {isEditing ? (
                  <input
                    value={formData.drivingLicense || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, drivingLicense: e.target.value })
                    }
                  />
                ) : (
                  fraud.drivingLicense
                )}
              </p>
            </div>

            <div>
              <h4>Location</h4>

              <p>
                <strong>Fraud City:</strong>{" "}
                {isEditing ? (
                  <input
                    value={formData.fraudCity || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, fraudCity: e.target.value })
                    }
                  />
                ) : (
                  fraud.fraudCity
                )}
              </p>

              <p><strong>Fraud Area:</strong> {fraud.fraudArea}</p>
              <p><strong>Aadhaar City:</strong> {fraud.aadhaarCity}</p>
              <p><strong>Aadhaar Area:</strong> {fraud.aadhaarArea}</p>
            </div>

            <div>
              <h4>Fraud Case</h4>

              <p>
                <strong>Type:</strong>{" "}
                {isEditing ? (
                  <input
                    value={formData.fraudType || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, fraudType: e.target.value })
                    }
                  />
                ) : (
                  fraud.fraudType
                )}
              </p>

              <p>
  <strong>Date:</strong>{" "}
  {isEditing ? (
    <input
      type="date"
      value={
        formData.fraudDate
          ? formData.fraudDate.substring(0, 10)
          : ""
      }
      onChange={(e) =>
        setFormData({
          ...formData,
          fraudDate: e.target.value
        })
      }
    />
  ) : (
    new Date(fraud.fraudDate).toLocaleDateString()
  )}
</p>

              <p>
                <strong>Reported By:</strong>{" "}
                {fraud.reportedBy?.name}
              </p>

              <p>
                <strong>Email:</strong>{" "}
                {fraud.reportedBy?.email}
              </p>
            </div>

          </div>

          <div className="admin-fraud-description">
            <strong>Description:</strong>

            {isEditing ? (
              <textarea
                value={formData.description || ""}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
                style={{ width: "100%", minHeight: "80px" }}
              />
            ) : (
              <p>{fraud.description}</p>
            )}
          </div>

          {/* ✅ Save / Cancel Buttons */}
          {isEditing && (
            <div style={{ marginTop: "20px" }}>
              <button className="approve-btn" onClick={saveChanges}>
                Save
              </button>

              <button
                className="reject-btn"
                onClick={() => setIsEditing(false)}
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </button>
            </div>
          )}
        </div>

        {fraud.proofImages && fraud.proofImages.length > 0 && (
          <div className="admin-card">
            <h3 className="admin-section-title">
              Uploaded Proof
            </h3>

            {fraud.proofImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="Fraud Proof"
                style={{
                  width: "250px",
                  marginRight: "10px",
                  borderRadius: "8px"
                }}
              />
            ))}
          </div>
        )}

      </div>
    </AdminLayout>
  );
};

export default AdminFraudDetails;